const getUser = () => {
	if (! window) return false;
	const user = window?.cj?.user;
	const id = user?.id;
	if (! id) return false;
	return user;
};

export default getUser;
